<template>
  <div id="forgotCredentials" class="container-24">
    <loading
      :show="showSpinner"
      label="Loading..."
      :overlay="true">
    </loading>

    <div class="container fc-container">
      <div class="row fc-section">
        <section class="col-sm-12 fc-desc-header">
          <h1 class="title-24">Reset Your Login Information</h1>
          <div class="card-text-container col-sm-12 fc-desc-text">
            <div class="text-24">
              <p>
                If you've created an account online before, but can't remember your username or password,
                click the tabs below to recover or reset your
                credentials. Never been here before? Click
                <a v-bind:href="registrationUrl" v-on:click="redirectToRegistration()" class="here-link">here</a> to create new account.
              </p>
            </div>
          </div>
        </section>
      </div>
      <div class="row error-message-section" v-if="forgotErrorMessage.length > 0">
        <section class="col-sm-12 alert alert-danger" role="alert" >
          <div>
            <a class="close marright10" aria-label="close" title="close" v-on:click="forgotErrorMessage = ''" >
              ×
            </a>
            <span class="marleft10">{{ forgotErrorMessage }}</span>
          </div>
        </section>
      </div>
    </div>

    <div class="container fc-container">

        <div class="row fc-section fc-end-page">
          <section class="card-24 col-md-12 fc-info-section">
            <div class="col-md-6">
              <div class="row">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :class="{active: activeTabName === tab.name }">
                    <a data-toggle="tab" href="#infoTab" @click.prevent="setActiveTabName(tab.name); onTabChange()">{{ tab.tabText }}</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content">
                <loading
                  :show="showSpinner"
                  label="Loading..."
                  :overlay="true">
                </loading>
                <div class="tab-pane" id="infoTab" :class="{active: infoTabActive}">
                  <!-- Member Number or Check in code -->
                  <form @submit.prevent="validateAndSubmitForm('form-1')" data-vv-scope="form-1">
                  <div class="row">
                    <div class="materialized col-xs-12">
                      <div class="materialized form-group">
                        <input type="text" class="form-control form-control-warning" id="fc-info-member-nbr" maxlength="15"
                               name="memberNbr" :class="{'input': true, 'is-danger': errors.has('form-1.memberNbr')}"
                               placeholder="Member Number or Check-In Code" v-model="fcInfo.memberNbr" v-validate="'required'">
                        <label for="fc-info-member-nbr">Member Number or Check-In Code</label>
                        <span class="input-group-btn btn btn-view pull-right">
                        <button type="button" class="btn btn-link"
                                v-on:click="showModalHelper = true">
                          <i class="fa fa-question-circle-o" aria-hidden="true" title="Where is my Member Number or Check-In Code?"></i>
                        </button>
                      </span>
                        <span v-show="errors.has('form-1.memberNbr')"
                              class="help is-danger">{{ errors.first('form-1.memberNbr') }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- Email Address -->
                    <div class="row">
                     <div class="materialized col-xs-12">
                      <div class="form-group materialized">
                        <input type="text" class="form-control form-control-warning" id="fc-info-email-addr"
                               name="emailAddr" ref="emailAddr" :class="{'input': true, 'is-danger': errors.has('form-1.emailAddr')}"
                               placeholder="Email Address" v-model="fcInfo.emailAddr" v-validate="'required|email'">
                        <label for="fc-info-email-addr">Email Address</label>
                        <span v-show="errors.has('form-1.emailAddr')"
                              class="help is-danger">{{ errors.first('form-1.emailAddr') }}</span>
                      </div>
                    </div>
                  </div>
                    <!-- Cancel and Continue buttons -->
                    <div class="row martop35">
                      <div class="materialized col-xs-12">
                        <div class="form-group">
                          <button id="cancel-btn1" class="btn btn-primary btn-block pull-left cancel-button"
                                  v-on:click="redirectToLogin()" type="button">Cancel</button>
                        </div>
                        <div class="form-group">
                          <button id="continue-btn1" class="btn btn-primary btn-block pull-right" type="submit">Continue</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade in" id="securityQuestionsTab" :class="{active: securityQuestionsTabActive}">
                  <!-- Security Question Text -->
                  <form @submit.prevent="validateAndSubmitForm('form-2')" data-vv-scope="form-2">
                  <div class="row">
                    <div class="materialized col-xs-12">
                      <div class="materialized form-group">
                        <input type="text" class="form-control form-control-warning" id="sc-info-question"
                               name="sc-info-question" :class="{'input': true, 'is-danger': errors.has('form-2.sc-info-question')}"
                               placeholder="Security Question" v-model="scInfo.question" disabled>
                        <label for="fc-info-member-nbr">Security Question</label>
                      </div>
                    </div>
                  </div>
                  <!-- Security Answer Input -->
                  <div class="row">
                    <div class="materialized col-xs-12">
                      <div class="form-group materialized">
                        <input type="text" class="form-control form-control-warning" id="sc-info-answer"
                               name="answer" ref="answer" :class="{'input': true, 'is-danger': errors.has('form-2.answer')}"
                               placeholder="Answer" v-model="scInfo.answer" v-validate="'required'">
                        <label for="sc-info-answer">Answer</label>
                        <span v-show="errors.has('form-2.answer')"
                              class="help is-danger">{{ errors.first('form-2.answer') }}</span>
                      </div>
                    </div>
                  </div>
                    <!-- Cancel and Continue buttons -->
                    <div class="row martop35">
                      <div class="materialized col-xs-12">
                        <div class="form-group">
                          <button id="cancel-btn2" class="btn btn-primary btn-block pull-left cancel-button"
                                  v-on:click="redirectToLogin()" type="button">Cancel</button>
                        </div>
                        <div class="form-group">
                          <button id="continue-btn2" class="btn btn-primary btn-block pull-right" type="submit">Continue</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane" id="confirmationTab" :class="{active: confirmationTabActive}">
                  <div class="row">
                    <div class="materialized col-xs-12">
                      <div class="materialized form-group">
                        <h4 class="title-24">Your Request is being processed.</h4><br />
                        <div class="text-24">
                          <p>
                            An email containing your {{this.activeTabName === 'usernameTab' ? 'username' : 'temporary password'}}
                            will be sent to the email address on file. Once received,
                            please return to Login page to access My24 Account.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Back to Login link -->
                  <div class="row">
                    <div class="materialized col-xs-12">
                      <div class="login-link form-group pull-left">
                        <a v-bind:href="loginUrl" v-on:click="redirectToLogin()" ><label class="labelPointer"><u>Back to Login</u></label></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-img-container right-side col-md-6">
              <img src="../assets/forgot-credentials-image.jpg" class="full-img" alt="Reset Login Information">
            </div>
          </section>
        </div>
    </div>
    <helper-modal v-if="showModalHelper" @close="showModalHelper = false"></helper-modal>
  </div>
</template>

<script>
  import loading from '@/components/Loading.vue'
  import { forgotCredentialsService } from '../services/ServiceContainer'
  import cfg from '../services/configuration/PropertiesConfiguration'
  import HelperModal from '../components/HelperModal.vue'

  export default {
    name: 'forgotCredentials',
    components: {
      'loading': loading,
      'helper-modal': HelperModal
    },
    data () {
      return {
        showSpinner: false,
        fcInfo: {
          memberNbr: '',
          emailAddr: ''
        },
        scInfo: {
          id: '',
          question: '',
          answer: ''
        },
        redirectURI: '',
        errorCode: '',
        errorMessage: '',
        forgotErrorMessage: '',
        activeTabName: '',
        infoTabActive: true,
        securityQuestionsTabActive: false,
        confirmationTabActive: false,
        showButtons: true,
        showModalHelper: false,
        confirmationText: '',
        registrationUrl: '',
        loginUrl: '',
        tabs: [
          {
            name: 'usernameTab',
            tabText: 'Forgot Username'
          },
          {
            name: 'passwordTab',
            tabText: 'Forgot Password'
          }
        ]
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.redirectURI = vm.$route.query.redirect_uri
      })
    },
    beforeCreate () {
    },
    mounted () {
      this.activeTabName = this.tabs[0].name
      this.registrationUrl = cfg.registrationUrl
      this.loginUrl = cfg.loginUrl
    },
    methods: {
      validateAndSubmitForm (scope) {
        this.$validator.validateAll(scope).then((result) => {
          //  if the result is true(no validation errors) then do the login
          if (this.infoTabActive && result) {
            this.getSecurityQuestions()
          } else if (this.securityQuestionsTabActive && this.activeTabName === 'usernameTab' && result) {
            this.submitForgotUsername()
          } else if (this.securityQuestionsTabActive && this.activeTabName === 'passwordTab' && result) {
            this.submitForgotPassword()
          } else {
          }
          return
        })
      },
      getSecurityQuestions () {
        return new Promise((resolve, reject) => {
          this.showSpinner = true
          forgotCredentialsService.getSecurityQuestions({
            memberNumber: this.fcInfo.memberNbr,
            email: this.fcInfo.emailAddr
          }).then((response) => {
            this.showSpinner = false
            this.infoTabActive = false
            this.securityQuestionsTabActive = true
            this.confirmationTabActive = false
            this.forgotErrorMessage = ''
            this.setData(response.data)
            resolve(response)
          }).catch((error) => {
            this.showSpinner = false
            if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
              this.forgotErrorMessage = error.response.data.errorMessage
            } else {
              this.forgotErrorMessage = 'There was an unexpected error when trying to submit information.'
            }
            reject(error)
          })
        })
      },
      submitForgotUsername () {
        this.showSpinner = true
        forgotCredentialsService.submitForgotUsername({
          memberNumber: this.fcInfo.memberNbr,
          securityQuestionId: this.scInfo.id,
          securityQuestionText: this.scInfo.question,
          securityAnswerText: this.scInfo.answer,
          credentialType: 'username'
        }).then(() => {
          this.showSpinner = false
          this.infoTabActive = false
          this.securityQuestionsTabActive = false
          this.confirmationTabActive = true
          this.showButtons = false
          this.confirmationText = 'username'
          this.forgotErrorMessage = ''
        }).catch((error) => {
          this.showSpinner = false
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            this.forgotErrorMessage = error.response.data.errorMessage
          } else {
            this.forgotErrorMessage = 'There was an unexpected error when trying to submit information.'
          }
        })
      },
      submitForgotPassword () {
        this.showSpinner = true
        forgotCredentialsService.submitForgotPassword({
          memberNumber: this.fcInfo.memberNbr,
          securityQuestionId: this.scInfo.id,
          securityQuestionText: this.scInfo.question,
          securityAnswerText: this.scInfo.answer,
          credentialType: 'password'
        }).then(() => {
          this.showSpinner = false
          this.infoTabActive = false
          this.securityQuestionsTabActive = false
          this.confirmationTabActive = true
          this.showButtons = false
          this.confirmationText = 'temporary password'
          this.forgotErrorMessage = ''
        }).catch((error) => {
          this.showSpinner = false
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            this.forgotErrorMessage = error.response.data.errorMessage
          } else {
            this.forgotErrorMessage = 'There was an unexpected error when trying to submit information.'
          }
        })
      },
      onTabChange () {
        this.infoTabActive = true
        this.securityQuestionsTabActive = false
        this.confirmationTabActive = false
        this.showButtons = true
        //  reset data
        this.fcInfo.memberNbr = ''
        this.fcInfo.emailAddr = ''
        this.scInfo.id = ''
        this.scInfo.question = ''
        this.scInfo.answer = ''
        this.$validator.reset()
        this.errors.clear('form-1')
        this.errors.clear('form-2')
      },
      /**
       * Sets the authentication token in cookie
       * @param responseData
       */
      setData (response) {
        this.scInfo.id = response.id
        this.scInfo.question = response.question
      },
      setActiveTabName (tabName) {
        this.activeTabName = tabName
      },
      redirectToLogin () {
        window.location.href = cfg.loginUrl
      },
      redirectToRegistration () {
        window.location.href = cfg.registrationUrl
      }
    }
  }
</script>

<style lang="scss">
  @import '../../node_modules/my-account-common-css/stylesheets/materialized.scss';
  @import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '../../node_modules/my-account-common-css/stylesheets/container.scss';

  .fc-container {
    .nav-tabs {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      border-bottom: 0;
      > li {
        margin: 0;
        width: 50%;
        background-color: #d5d2ca;
        border: 0 !important;
        &.active > a,
        &.active > a:hover,
        &.active > a:focus {
          color: #ffffff !important;
          border: 0 !important;
          background-color: #EA1929 !important;
        }
        &:first-child > a {
          border: 0 !important;
        }
        &:last-child > a {
          border: 0 !important;
        }
        > a {
          height: 100%;
          flex-direction: column;
          display: flex;
          justify-content: center;
          border-radius: 0 !important;
          border: 0 !important;
          color: #a3a5a7 !important;
          margin: 0;
          padding: 20px 40px;
        }
      }
    }

    padding: 0 20px;
    .section-separator {
      border-bottom: #EA1929;
      margin-top: -8px;
      margin-bottom: 1px;
      width: 100%;
    }

    .login-link {
      color: blue;
      margin-left: 15px;
      margin-top: 10px;
      margin-bottom: 10px;
      float: right;
      #label {
        top: 0;
      }
    }

    .here-link {
      color: blue;
      font-weight: bold;
      text-decoration: underline;
    }

    #cancel-btn1, #cancel-btn2 {
      background-color: white;
      color: black;
      border: 1px solid;
    }

    .fc-section {
      margin-top: 15px;
    }

    .fc-info-section {
      padding: 0 0 0 0;
    }

    .col-sm-12, .col-xs-12 {
      padding-left: 0px;
    }

    .col-md-6 {
      padding-right: 30px;
    }

    .fc-desc-header {
      position: relative;
    }

    .login-desc {
      .fc-desc-text {
        p {
          text-align: justify;
          margin-top: 10px;
          margin-left: 0px;
        }
      }
    }

    .fc-end-page {
      margin-bottom: 100px;
    }

    .card-24 {
      float: left;
      border-top: 2px solid #eb2131;
      margin-bottom: 24px;
      width: 100%;
    }

    .martop10 {
      margin-top: 10px;
    }

    .martop15 {
      margin-top: 15px;
    }

    .martop20 {
      margin-top: 20px;
    }

    .martop35 {
      margin-top: 35px;
    }

    .marleft10 {
      margin-left: 10px;
      display: block;
    }

    .marright10 {
      margin-right: 10px;
    }

    .materialized {
      .form-group {
        margin: 15px 0 10px;

        input.form-control[disabled] {
          color: #4d4e53;
          border-color: #adadad;
          + * {
            color: #4d4e53;
          }
        }
      }
      .btn-primary {
        width: 45%;
        font-weight: 500;
      }
    }

    [class*="-desc-header"] {
      position: relative;

      .card-24 {
        width: 100%;
      }
    }

    .labelPointer {
      cursor: pointer;
    }

    .fa {
      font-size: 18px;
    }

    > li {
      &.active > a {
        background-color: #EA1929 !important;
      }
    }
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {
    .fc-container {
      margin: 0 10px 0 10px;

      .col-md-6, .col-xs-12, .col-xs-6 {
        padding: 0 10px 0 10px;
      }

      .fc-section, .fc-info-section {
        padding: 0 10px 0 10px;
      }

      .col-sm-12 {
        padding: 0 0 0 0;
      }

      .fc-helper-link {
        text-align: right;
      }

      .error-message-section {
        padding: 0 15px 0 15px !important;
      }
    }

    .container-24 .card-24 .card-img-container {
      display: none;
    }

    .controls-top, .controls-bottom {
      .info {
        display: inline;
      }
    }

    /* Small devices (tablets, 768px and up) */
    @media (min-width: $screen-sm-min) {

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ForgotCredentials.vue